import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgThumbsDownFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M0.859988 13.5C1.23999 13.94 1.78999 14.19 2.36999 14.19L6.57999 14.19L6.57999 17.54C6.57999 19.32 7.63999 21.2 9.59999 21.2C10.51 21.2 11.26 20.46 11.26 19.54L11.26 16.46C11.26 13.88 13.36 11.78 15.94 11.78L16.4 11.78L16.4 12.59C16.4 12.92 16.67 13.19 17 13.19L21.2 13.19C21.53 13.19 21.8 12.92 21.8 12.59L21.8 2.15001C21.8 1.82001 21.53 1.55001 21.2 1.55001L17 1.55001C16.67 1.55001 16.4 1.82001 16.4 2.15001L16.4 2.57001L15.87 2.57001C15.68 2.57001 15.5 2.52001 15.34 2.43001L13.88 1.52001C13.56 1.32001 13.2 1.22001 12.82 1.22001L3.70999 1.22001C2.66999 1.22001 1.81999 2.00001 1.71999 3.01001L0.389989 11.89C0.299989 12.47 0.469988 13.05 0.849988 13.49L0.859988 13.5ZM17.6 2.77001L20.6 2.77001L20.6 12.01L17.6 12.01L17.6 2.77001Z"
	})
});
export { SvgThumbsDownFilled as ReactComponent };
